/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1TaxcodesQueryResponse } from '../../types/GetV1Taxcodes.ts'

export const getV1TaxcodesQueryKey = () => [{ url: '/v1/TaxCodes' }] as const

export type GetV1TaxcodesQueryKey = ReturnType<typeof getV1TaxcodesQueryKey>

/**
 * {@link /v1/TaxCodes}
 */
export async function getV1Taxcodes(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1TaxcodesQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/TaxCodes`,
        ...requestConfig,
    })
    return res
}

export function getV1TaxcodesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1TaxcodesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1TaxcodesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1TaxcodesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Taxcodes(config)
        },
    })
}

/**
 * {@link /v1/TaxCodes}
 */
export function useGetV1Taxcodes<
    TData = ResponseConfig<GetV1TaxcodesQueryResponse>,
    TQueryData = ResponseConfig<GetV1TaxcodesQueryResponse>,
    TQueryKey extends QueryKey = GetV1TaxcodesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1TaxcodesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1TaxcodesQueryKey()

    const query = useQuery(
        {
            ...getV1TaxcodesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
